import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-directorysubmission',
  templateUrl: './directorysubmission.component.html',
  styleUrls: ['./directorysubmission.component.scss']
})
export class DirectorysubmissionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
